<template>
  <div>
    <table-base ref="table" :GetAction="'GetSeachList'" :Controller="'ExHelper'" :TopButtons="TopButtons" :FormParams="FormParams" TableButtonWidth="180px"
    :TopSeach="TopSeach" :TableColumns="TableColumns" :TableButtons="TableButtons" @tableButtonClick="tableButtonClick"></table-base>
  </div>
</template>

<script>
  export default {
    name: "ExRole",
    title: "审批角色",
    data () {
      return {
        model: {},
        TopButtons: [
          { name: "添加", action: "add", type: "primary" }
        ],
        TopSeach: [
          { name: "", param: "input", default: "", type: "text", placeholder: "请输入关键字" },
        ],
        TableColumns: [
          { name: "序号", type: "index", param: "", width: "50px" },
          { name: "角色名", param: "roleName" },
          { name: "审批权限", param: "isPresent", format: (val) => { val == 1 ? '所属部门' : val == 2 ? '所属中心' : '全局' } },
        ],
        TableButtons: [
          { name: "编辑", action: "update" },
          { name: "设置人员", action: "user", checkType: 2, multiple: true, default: [], back: this.SetUser },
          { name: "删除", action: "del", color: "#f56c6c" },
        ],
        FormParams: [
          { name: "名称", param: "roleName", default: "", placeholder: "请输入类型名称" },
          { name: "审批权限", param: "isPresent", type: "select", select: [{ value: 1, label: '所属部门' }, { value: 2, label: '所属中心' }, { value: 3, label: '全局' }] },
        ]
      }
    },

    components: {
      TableBase: resolve => require(["@/components/System/components/TableBase"], resolve)
    },
    mounted () {

    },
    methods: {
      tableButtonClick (row, type) {
        if (type == "user") {
          if (row.users) {
            this.TableButtons[1].default = JSON.parse(row.users);
          } else {
            this.TableButtons[1].default = [];
          }
          this.model = row;
        }
      },
      SetUser (dt) {
        this.model.users = JSON.stringify(dt);
        this.Ajax.Post("/api/ExHelper/AddOrUpdate", this.model).then(res => {
          this.$tool.System.msg("操作成功！", "提示", 0);
          this.$refs.table.visible = false;
          this.$refs.table.GetList();
        })
      }
    },
  }
</script>